// TMOS Template Entity Definition
// Date: January 26, 2025
// Purpose: Entity definition for template management with FlexibleCRUDTable

import React from 'react';

export const templateEntity = {
  name: 'Template',
  displayName: 'Template',
  tableName: 'templates',
  primaryKey: 'id',
  displayFields: ['name', 'template_type', 'owner_name', 'owner_email', 'created_at', 'marketplace_visibility'],
  tableColumns: [
    {
      key: 'name',
      label: 'Name',
      width: '160px',
      render: (value: any, item: any) =>
        React.createElement('span', {
          title: item?.description ?? '',
          className: 'cursor-default'
        }, value ?? '')
    },
    { key: 'template_type', label: 'Type', width: '110px' },
    { key: 'owner_name', label: 'Owner Name', width: '100px' },
    { key: 'owner_email', label: 'Owner Email', width: '140px' },
    { key: 'created_at', label: 'Created At', width: '100px' },
    {
      key: 'marketplace_visibility',
      label: 'Visibility',
      width: '90px',
      render: (value: any, _item: any, _onUpdate?: () => void) => {
        return value || 'DRAFT';
      }
    }
  ],
  fields: [
    {
      key: 'id',
      name: 'id',
      displayName: 'ID',
      type: 'string',
      required: true,
      hidden: true
    },
    {
      key: 'name',
      name: 'name',
      displayName: 'Name',
      type: 'string',
      required: true,
      searchable: true,
      sortable: true
    },
    {
      key: 'description',
      name: 'description',
      displayName: 'Description',
      type: 'text',
      required: false,
      searchable: true,
      sortable: false
    },
    {
      key: 'template_type',
      name: 'template_type',
      displayName: 'Type',
      type: 'select',
      required: true,
      searchable: true,
      sortable: true,
      options: [
        { value: 'ROADMAP', label: 'Roadmap' },
        { value: 'PROJECT_STRUCTURE', label: 'Project Structure' },
        { value: 'HIERARCHY', label: 'Hierarchy' },
        { value: 'PROCESS_AREAS', label: 'Process Areas' },
        { value: 'POSITION', label: 'Position' },
        { value: 'ROLE', label: 'Role' },
        { value: 'USER', label: 'User' },
        { value: 'KPI', label: 'KPI' },
        { value: 'REPORT', label: 'Report' },
        { value: 'RISK', label: 'Risk' },
        { value: 'COMMUNICATION', label: 'Communication' },
        { value: 'CHANGE_MANAGEMENT', label: 'Change Management' },
        { value: 'PROFILE', label: 'Profile' }
      ]
    },
    {
      key: 'sub_type',
      name: 'sub_type',
      displayName: 'Sub Type',
      type: 'string',
      required: false,
      searchable: true,
      sortable: true
    },
    {
      key: 'industry_type',
      name: 'industry_type',
      displayName: 'Industry',
      type: 'string',
      required: false,
      searchable: true,
      sortable: true
    },
    {
      key: 'marketplace_visibility',
      name: 'marketplace_visibility',
      displayName: 'Marketplace Visibility',
      type: 'select',
      required: false,
      searchable: false,
      sortable: true,
      options: [
        { value: 'DRAFT', label: 'Draft' },
        { value: 'PRIVATE', label: 'Private' },
        { value: 'PUBLIC', label: 'Public' }
      ]
    },
    {
      key: 'version',
      name: 'version',
      displayName: 'Version',
      type: 'string',
      required: false,
      searchable: false,
      sortable: true
    },
    {
      key: 'created_by',
      name: 'created_by',
      displayName: 'Created By',
      type: 'string',
      required: false,
      searchable: true,
      sortable: true,
      hidden: true
    },
    {
      key: 'owner_name',
      name: 'owner_name',
      displayName: 'Owner Name',
      type: 'string',
      required: false,
      searchable: true,
      sortable: true
    },
    {
      key: 'owner_email',
      name: 'owner_email',
      displayName: 'Owner Email',
      type: 'string',
      required: false,
      searchable: true,
      sortable: true
    },
    {
      key: 'created_at',
      name: 'created_at',
      displayName: 'Created At',
      type: 'datetime',
      required: false,
      searchable: false,
      sortable: true
    },
    {
      key: 'updated_at',
      name: 'updated_at',
      displayName: 'Updated At',
      type: 'datetime',
      required: false,
      searchable: false,
      sortable: true
    }
  ],
  relationships: [],
  permissions: {
    create: true,
    read: true,
    update: true,
    delete: true
  }
};
